import { useCallback } from 'react';

import type { PaymentErrors } from 'constants/payment';
import type { TranslationKey } from 'locales/flattenMessages';
import { getPaymentErrorKey, getTranslationKey } from 'utils/get-payment-error';

import { useTranslate } from './useTranslate';

const usePaymentError = () => {
  const { t } = useTranslate();

  const getPaymentError = useCallback(
    (errorCode?: string, altMessage?: TranslationKey): string => {
      if (errorCode) {
        if (getTranslationKey(errorCode)) {
          const key = getPaymentErrorKey(errorCode as keyof typeof PaymentErrors, altMessage);

          return t(key);
        }

        return errorCode;
      }

      return t('error');
    },
    [t],
  );

  return { getPaymentError };
};

export { usePaymentError };
